module.exports = __webpack_public_path__ + "static/media/app_logo.07b650d1.png";